import { useQuery } from "@tanstack/react-query";
import { useOspApiClientProvider } from "@hooks";
import { QUERY_KEYS } from "@config";

const PAGE_SIZE = 1;
const LIMIT = 15;

/**
 * 填充数组至指定长度
 * @param arr 原始数组
 * @param targetLength 目标长度
 * @returns 填充后的数组
 */
const fillArrayToLength = <T>(arr: T[], targetLength: number): T[] => {
  if (arr.length === 0 || arr.length >= targetLength) {
    return arr.slice(0, targetLength);
  }

  // 计算需要重复的次数
  const repeatCount = Math.ceil(targetLength / arr.length);
  // 使用 Array.from 和 flatMap 一次性创建填充后的数组
  return Array.from({ length: repeatCount })
    .flatMap(() => arr)
    .slice(0, targetLength);
};

export const useListData = () => {
  const { openApi } = useOspApiClientProvider();
  const { data, isPending } = useQuery({
    queryKey: [QUERY_KEYS.KOL_FOLLOW],
    enabled: !!openApi,
    queryFn: async () => {
      const res = await openApi?.kol.listKolFollow({
        limit: LIMIT,
        page_size: PAGE_SIZE,
      });

      // 过滤有效数据并填充至目标长度
      const validRows =
        res?.data?.data?.rows?.filter((item) => !!item?.token_handle) || [];
      return fillArrayToLength(validRows, LIMIT);
    },
  });

  return {
    data,
    isPending,
  };
};
